import { useState, useEffect, useRef } from "react";
import { Box, Typography, Button, TextField, MenuItem  } from "@mui/material";
import CustomDialog from "../../components-new/common/CustomDialog";
import useFailureAnalysisPrefillQuery from "../../useQuery/useFailureAnalysisPrefillQuery";


const AnalyzeDialog = ({ open, onClose, testcaseid, testcasename }) => {
  const [analyzeText, setAnalyzeText] = useState("");
  const [errorStep, setErrorStep] = useState("");
  const [checkSteps, setCheckSteps] = useState("3");
  const [option, setOption] = useState("2");

  const { data: prefillData } = useFailureAnalysisPrefillQuery(testcaseid, open);

  const prefilledRef = useRef(false);

  useEffect(() => {
    if (prefillData && !prefilledRef.current) {
      setAnalyzeText(prefillData.testcase_description ?? "");
      setErrorStep(
        prefillData.failed_step_number != null ? String(prefillData.failed_step_number) : ""
      );
      prefilledRef.current = true;
    }
  }, [prefillData]);

  useEffect(() => {
    if (!open) prefilledRef.current = false;
  }, [open]);

 const handleAnalyzeSubmit = () => {
    const params = new URLSearchParams({
      tcid: testcaseid,
      description: analyzeText,
      testcasename,
      errorstep: errorStep,
      checktillsteps: checkSteps,
      option,
    });
    window.open(`/new/analyze-report?${params.toString()}`, "_blank");
    onClose();
  };

  return (
    <CustomDialog
      open={open}
      onClose={onClose}
      title="Describe the test case"
      content={
        <Box display="flex" flexDirection="column" rowGap={2} sx={{ mt: 1 }}>
          <Box display="flex" flexDirection="column" rowGap={0.5}>
            <Typography sx={{ fontSize: "14px", fontWeight: 600 }}>Description</Typography>
            <TextField
              multiline
              minRows={4}
              value={analyzeText}
              onChange={(e) => setAnalyzeText(e.target.value)}
              fullWidth
            />
          </Box>
          <Box display="flex" columnGap={2}>
  <Box display="flex" flexDirection="column" rowGap={0.5} flex={1}>
    <Typography sx={{ fontSize: "14px", fontWeight: 600 }}>Error Step</Typography>
    <TextField
      type="number"
      value={errorStep}
      onChange={(e) => setErrorStep(e.target.value)}
      fullWidth
    />
  </Box>
  <Box display="flex" flexDirection="column" rowGap={0.5} flex={1}>
    <Typography sx={{ fontSize: "14px", fontWeight: 600 }}>Check Steps</Typography>
    <TextField
      type="number"
      value={checkSteps}
      onChange={(e) => setCheckSteps(e.target.value)}
      fullWidth
    />
  </Box>
</Box>

<Box display="flex" flexDirection="column" rowGap={0.5}>
  <Typography sx={{ fontSize: "14px", fontWeight: 600 }}>Analysis Mode</Typography>
  <TextField
    select
    value={option}
    onChange={(e) => setOption(e.target.value)}
    fullWidth
  >
    <MenuItem value="2">Compare logs + screenshots (most comprehensive)</MenuItem>
  </TextField>
</Box>
        </Box>
      }
      actions={
        <>
          <Button onClick={onClose} sx={{ textTransform: "none" }}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleAnalyzeSubmit}
            disabled={!analyzeText.trim()}
            sx={{ textTransform: "none" }}
          >
            Analyze
          </Button>
        </>
      }
    />
  );
};

export default AnalyzeDialog;